import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { XIcon, SparklesIcon } from 'lucide-react';
export function Nadi() {
  const {
    t
  } = useTranslation('analytics');
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(true);
  const handleCloseModal = () => {
    setShowModal(false);
    navigate('/reports');
  };
  return <div className="flex gap-6" data-id="element-2461">
      {/* Left Sidebar - Report Templates */}
      <div className="w-64 flex-shrink-0" data-id="element-2462">
        <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-2463">
          <input type="search" aria-label={t('components.content.attrs.search')} placeholder={t('components.content.attrs.search')} className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md mb-4" data-id="element-2464" />

          <div className="space-y-6" data-id="element-2465">
            <div data-id="element-2466">
              <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2" data-id="element-2467">
                {t('pages.Nadi.basic_reports')}
              </h3>
              <div className="space-y-1" data-id="element-2468">
                <button className="w-full text-left px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-md" data-id="element-2469">
                  <div className="font-medium" data-id="element-2470">
                    {t('pages.Nadi.daily_activity')}
                  </div>
                  <div className="text-xs text-gray-500" data-id="element-2471">
                    {t('pages.Nadi.sales_refunds_adjustments_and_disputes')}
                  </div>
                </button>
                <button className="w-full text-left px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-md" data-id="element-2472">
                  <div className="font-medium" data-id="element-2473">
                    {t('pages.Nadi.daily_balance')}
                  </div>
                  <div className="text-xs text-gray-500" data-id="element-2474">
                    {t('pages.Nadi.account_balance_and_activity_summary')}
                  </div>
                </button>
                <button className="w-full text-left px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-md" data-id="element-2475">
                  <div className="font-medium" data-id="element-2476">
                    {t('pages.Nadi.monthly_summary_and_balance')}
                  </div>
                  <div className="text-xs text-gray-500" data-id="element-2477">
                    {t('pages.Nadi.sales_refunds_gross_and_net_activity')}
                  </div>
                </button>
                <button className="w-full text-left px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-md" data-id="element-2478">
                  <div className="font-medium" data-id="element-2479">
                    {t('pages.Nadi.gross_volume')}
                  </div>
                  <div className="text-xs text-gray-500" data-id="element-2480">
                    {t('pages.Nadi.gross_volume_query_used_to_match')}
                  </div>
                </button>
                <button className="w-full text-left px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-md" data-id="element-2481">
                  <div className="font-medium" data-id="element-2482">
                    {t('pages.Nadi.failed_payments')}
                  </div>
                  <div className="text-xs text-gray-500" data-id="element-2483">
                    {t('pages.Nadi.failed_payments_sorted_by_descending_order')}
                  </div>
                </button>
                <button className="w-full text-left px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-md" data-id="element-2484">
                  <div className="font-medium" data-id="element-2485">
                    {t('pages.Nadi.new_customers')}
                  </div>
                  <div className="text-xs text-gray-500" data-id="element-2486">
                    {t('pages.Nadi.monthly_count_of_new_customers')}
                  </div>
                </button>
              </div>
            </div>

            <div data-id="element-2487">
              <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2" data-id="element-2488">
                {t('pages.Nadi.payments_payouts_and_transfers')}
              </h3>
              <div className="space-y-1" data-id="element-2489">
                <button className="w-full text-left px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-md" data-id="element-2490">
                  <div className="font-medium" data-id="element-2491">
                    {t('pages.Nadi.gross_charge_volume_by_month')}
                  </div>
                  <div className="text-xs text-gray-500" data-id="element-2492">
                    {t('pages.Nadi.total_processing_volume_for_each_currency')}
                  </div>
                </button>
                <button className="w-full text-left px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-md" data-id="element-2493">
                  <div className="font-medium" data-id="element-2494">
                    {t('pages.Nadi.payment_card_breakdown')}
                  </div>
                  <div className="text-xs text-gray-500" data-id="element-2495">
                    {t('pages.Nadi.charges_and_amounts_for_each_card')}
                  </div>
                </button>
                <button className="w-full text-left px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-md" data-id="element-2496">
                  <div className="font-medium" data-id="element-2497">
                    {t('pages.Nadi.payments_info_breakdown')}
                  </div>
                  <div className="text-xs text-gray-500" data-id="element-2498">
                    {t('pages.Nadi.summary_of_address_info_submitted_with')}
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content Area */}
      <div className="flex-1" data-id="element-2499">
        <div className="flex items-center gap-4 mb-6" data-id="element-2500">
          <h1 className="text-2xl font-semibold text-gray-400" data-id="element-2501">
            {t('pages.Nadi.untitled_report')}
          </h1>
          <button className="text-gray-400 hover:text-gray-600" data-id="element-2502">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" data-id="element-2503">
              <path d="M11.013 2.513a1.75 1.75 0 012.475 2.474l-8.61 8.61a.75.75 0 01-.353.194l-3.75.75a.75.75 0 01-.877-.877l.75-3.75a.75.75 0 01.194-.353l8.61-8.61z" data-id="element-2504" />
            </svg>
          </button>
        </div>

        <div className="flex gap-4 mb-6 border-b border-gray-200" data-id="element-2505">
          <button className="px-4 py-2 text-sm font-medium text-gray-700 border-b-2 border-transparent hover:border-gray-300" data-id="element-2506">
            {t('pages.Nadi.reports')}
          </button>
          <button className="px-4 py-2 text-sm font-medium text-gray-700 border-b-2 border-transparent hover:border-gray-300" data-id="element-2507">
            {t('pages.Nadi.schema')}
          </button>
          <button className="px-4 py-2 text-sm font-medium text-blue-600 border-b-2 border-blue-600" data-id="element-2508">
            {t('pages.Nadi.templates')}
          </button>
        </div>

        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 flex items-start gap-3 mb-4" data-id="element-2509">
          <SparklesIcon size={20} className="text-blue-600 flex-shrink-0 mt-0.5" data-id="element-2510" />

          <div className="flex-1" data-id="element-2511">
            <p className="text-sm text-gray-700" data-id="element-2512">
              <button className="font-medium text-blue-600 hover:text-blue-700" data-id="element-2513">
                {t('pages.Nadi.generate')}
              </button>
              {' | '}
              <button className="font-medium text-blue-600 hover:text-blue-700" data-id="element-2514">
                {t('pages.Nadi.ask_nadi_assistant')}
              </button>{' '}
              {t('pages.Nadi.ex_get_me_all_connected_accounts')}
            </p>
          </div>
        </div>

        <div className="bg-[var(--brand-primarysubtle)] border border-[var(--brand-primarylight)] rounded-lg p-4 flex items-start gap-3" data-id="element-2515">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor" className="text-emerald-600 flex-shrink-0 mt-0.5" data-id="element-2516">
            <path fillRule="evenodd" d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z" clipRule="evenodd" data-id="element-2517" />
          </svg>
          <div className="flex-1" data-id="element-2518">
            <p className="text-sm text-gray-700" data-id="element-2519">
              {t('pages.Nadi.a_nadi_plan_is_required_to')}
            </p>
            <p className="text-sm text-gray-600 mt-1" data-id="element-2520">
              {t('pages.Nadi.we_have_already_been_notified_of')}
            </p>
          </div>
        </div>
      </div>

      {/* Modal */}
      {showModal && <>
          <div className="fixed inset-0 bg-black bg-opacity-50 z-40" onClick={handleCloseModal} data-id="element-2521" />

          <div className="fixed inset-0 flex items-center justify-center z-50 p-4" data-id="element-2522">
            <div className="bg-white rounded-lg shadow-2xl max-w-2xl w-full p-8 relative" data-id="element-2523">
              <button onClick={handleCloseModal} aria-label="Close" className="absolute top-4 right-4 text-gray-400 hover:text-gray-600" data-id="element-2524">
                <XIcon size={24} aria-hidden="true" data-id="element-2525" />
              </button>

              <h2 className="text-2xl font-semibold text-gray-900 mb-6" data-id="element-2526">
                {t('pages.Nadi.custom_reporting_with_an_ai_assistant')}
              </h2>

              <div className="flex gap-6" data-id="element-2527">
                {/* Left side - Preview */}
                <div className="flex-shrink-0" data-id="element-2528">
                  <div className="bg-gradient-to-br from-purple-100 to-blue-100 rounded-lg p-4 w-64" data-id="element-2529">
                    <div className="bg-white rounded-lg p-4 shadow-sm" data-id="element-2530">
                      <div className="flex items-center justify-between mb-3" data-id="element-2531">
                        <h3 className="text-sm font-semibold text-gray-900" data-id="element-2532">
                          {t('pages.Nadi.gross_volume_2')}
                        </h3>
                        <button className="text-xs text-gray-500" data-id="element-2533">
                          {t('pages.Nadi.edit')}
                        </button>
                      </div>
                      <p className="text-xs text-gray-500 mb-3" data-id="element-2534">
                        {t('pages.Nadi.show_recurring_payments_under_usd_24')}
                      </p>

                      {/* Mini chart */}
                      <div className="h-24" data-id="element-2535">
                        <svg width="100%" height="100%" viewBox="0 0 200 80" className="text-blue-600" data-id="element-2536">
                          <polyline points="10,60 30,50 50,55 70,40 90,45 110,35 130,40 150,25 170,30 190,20" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-2537" />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Right side - Content */}
                <div className="flex-1" data-id="element-2538">
                  <p className="text-gray-700 mb-4" data-id="element-2539">
                    {t('pages.Nadi.get_quick_answers_to_complex_data')}
                  </p>

                  <p className="text-gray-700 mb-4" data-id="element-2540">
                    {t('pages.Nadi.try_it_free_until_january_4')}{' '}
                    <span className="font-medium" data-id="element-2541">
                      {t('pages.Nadi.usd_50month')}
                    </span>
                    {t('pages.Nadi.plus_a')}{' '}
                    <a href="#" className="text-blue-600 hover:text-blue-700 underline" data-id="element-2542">
                      {t('pages.Nadi.per_charge_fee')}
                    </a>
                    .
                  </p>

                  <p className="text-xs text-gray-600 mb-6" data-id="element-2543">
                    {t('pages.Nadi.by_clicking_start_free_trial_you')}{' '}
                    <a href="#" className="text-blue-600 hover:text-blue-700 underline" data-id="element-2544">
                      {t('pages.Nadi.settings')}
                    </a>
                    .
                  </p>

                  <div className="flex gap-3" data-id="element-2545">
                    <button className="px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-md shadow-sm" data-id="element-2546">
                      {t('pages.Nadi.start_free_trial')}
                    </button>
                    <button className="px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 rounded-md" data-id="element-2547">
                      {t('pages.CardMonitoringPrograms.learn_more')}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>}
    </div>;
}